import moment from 'moment';
import { Button } from 'reactstrap';
import isAuthorized from '../../../../../helpers/isAuthorized';
import {
  canUpdatePerformanceModule,
  canDeletePerformanceManagement,
} from '../../../../../helpers/performanceManagementPermissions';
import { Context as AuthContext } from '../../../../../contexts/AuthContext';
import React, { useContext } from 'react';

export const getFeedbackPendingColumns = (
  setItemFeedbackSummaryModal: (data: any) => void,
  setShowFeedbackSummaryModal: (show: boolean) => void,
  handleApproveOrDeny: (e: React.FormEvent, action: string, type: string, id: string) => void,
  handleEdit: (row: any) => void,
  onDelete?: (e: React.FormEvent, row: any) => void,
) => {
  const { user }: any = useContext(AuthContext);

  return [
    {
      name: 'Employee',
      selector: (row: any) => `${row?.name}`,
      sortable: true,
      width: '300px',
    },
    {
      name: 'Created',
      selector: (row: any) => row.createdAt,
      sortable: true,
      format: (row: any) => (row.createdAt ? moment.utc(row.createdAt).format('MM/DD/YYYY') : '-'),
      width: '120px',
    },
    {
      name: 'Incident Date',
      selector: (row: any) => row.dateOfIncident,
      sortable: true,
      format: (row: any) => (row.dateOfIncident ? moment.utc(row.dateOfIncident).format('MM/DD/YYYY') : '-'),
      width: '120px',
    },
    {
      name: 'Policy Violated',
      selector: (row: any) => {
        if (row.policyViolations && Array.isArray(row.policyViolations)) {
          return row.policyViolations.map((pv: any) => pv.name || pv).join(', ');
        }
        if (row.policyViolationIds && Array.isArray(row.policyViolationIds)) {
          return row.policyViolationIds.join(', ');
        }
        if (row.policyViolation?.name) {
          return row.policyViolation.name;
        }
        if (row.policy_violated) {
          return row.policy_violated;
        }
        return 'N/A';
      },
      sortable: true,
      width: '330px',
    },
    {
      name: 'Immediate Feedback',
      selector: (row: any) => row.immediateFeedback,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Actions',
      cell: (row: any) => (
        <div className="d-flex justify-content-center">
          <Button
            outline
            color="info"
            size="sm"
            style={{ padding: '0.1rem 0.4rem', border: 'none' }}
            title="View Details"
            onClick={() => {
              const dataRow = row;
              dataRow.data = row;
              console.log(dataRow);
              setItemFeedbackSummaryModal([dataRow]);
              setShowFeedbackSummaryModal(true);
            }}
          >
            <i className="fas fa-eye" />
          </Button>
          {canUpdatePerformanceModule('PerformanceFeedback', user) && (
            <Button
              outline
              color="warning"
              size="sm"
              style={{ padding: '0.1rem 0.4rem', border: 'none' }}
              title="Edit"
              onClick={() => handleEdit(row)}
            >
              <i className="fas fa-edit" />
            </Button>
          )}
          {/* {isAuthorized({ moduleName: 'PerformanceFeedback', functionName: 'Approve' }, user) && (
            <Button
              outline
              color="success"
              size="sm"
              style={{ padding: '0.1rem 0.4rem', border: 'none' }}
              title="Approve"
              onClick={(e: any) => {
                handleApproveOrDeny(e, 'approve', 'feedback', row?.id);
              }}
            >
              <i className="fas fa-check" />
            </Button>
          )} */}
          {isAuthorized({ moduleName: 'PerformanceFeedback', functionName: 'Reject' }, user) && (
            <Button
              outline
              color="danger"
              size="sm"
              style={{ padding: '0.1rem 0.4rem', border: 'none' }}
              title="Deny"
              onClick={(e: any) => {
                handleApproveOrDeny(e, 'reject', 'feedback', row?.id);
              }}
            >
              <i className="fas fa-ban" />
            </Button>
          )}
          {canDeletePerformanceManagement(user) && (
            <Button
              outline
              color="danger"
              size="sm"
              style={{ padding: '0.1rem 0.4rem', border: 'none' }}
              title="Delete"
              onClick={(e: any) => onDelete?.(e, row)}
            >
              <i className="fas fa-trash" />
            </Button>
          )}
        </div>
      ),
      width: '120px',
      center: true,
    },
  ];
};
